import http from "@/http-common";

class SchoolDataMigrationService {
  create(data, key) {
    return http.post("/migration/school-data", data, { headers: { "Idempotency-Key": key } });
  }
  list(page = 1, limit = 20) {
    return http.get("/migration/school-data/jobs", { params: { page, limit } });
  }
  get(jobId) {
    return http.get(`/migration/school-data/jobs/${encodeURIComponent(jobId)}`);
  }
}

export default new SchoolDataMigrationService();
